import React, { createContext, useContext } from 'react';
import brandingConfig from '../config/brandingConfig';

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  return (
    <BrandingContext.Provider value={brandingConfig}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const context = useContext(BrandingContext);
  if (!context) {
    // Fallback if used outside provider — import config directly
    return brandingConfig;
  }
  return context;
}

export default BrandingContext;
